const Tw = (props) => (
  <svg viewBox='0 0 32 32' fill='none' {...props}>
    <path fillRule='evenodd' clipRule='evenodd'
      d='M15.8612 31.8688C24.6124 31.8688 31.7067 24.7745 31.7067 16.0233C31.7067 7.27203 24.6124 0.177734 15.8612 0.177734C7.10992 0.177734 0.015625 7.27203 0.015625 16.0233C0.015625 24.7745 7.10992 31.8688 15.8612 31.8688ZM22.4177 9.82919L17.2172 15.8488H17.2169L22.873 24.0454H18.7132L14.9044 18.5258L10.1358 24.0454H8.90342L14.3573 17.7329L8.90342 9.82919H13.0632L16.6698 15.0559L21.1853 9.82919H22.4177ZM14.9766 17.0155L15.5292 17.8026V17.8029L19.293 23.1636H21.1859L16.5736 16.5941L16.021 15.8071L12.4728 10.753H10.5799L14.9766 17.0155Z'
      fill='#FFE42B' />
  </svg>
)

export default Tw



// WEBPACK FOOTER //
// ./components/icons/tw.js